/**
* Loads the Klaviyo script for lead capture on pages by adding klaviyo form integration.
*/

import { MiaPlaza } from "@/Reinforced.Typings";
import { ScriptLoader } from "@/utils/ScriptLoader";

export default class Klaviyo {
	private readonly options: MiaPlaza.Control.Tracking.IKlaviyoFormTrackingOptions;
	private loaded = false;

	constructor(options: MiaPlaza.Control.Tracking.IKlaviyoFormTrackingOptions) {
		this.options = options;
	}

	public load(): void {
		if (this.loaded) {
			return;
		}

		if (!this.options.PublicKey) {
			return;
		}

		ScriptLoader.LoadScript(`https://static.klaviyo.com/onsite/js/${this.options.PublicKey}/klaviyo.js`);

		this.loaded = true;
	}
}
